import React, { useEffect, useState } from "react";

import $ from "jquery";
import { Checkbox } from "semantic-ui-react";

function ImageOptions(props) {
    const [active, setActive] = useState((props.option) ? props.option : (localStorage.getItem("checkbox-option")) ? localStorage.getItem("checkbox-option") : "random");

    useEffect(() => {
        setActive((props.option) ? props.option : (localStorage.getItem("checkbox-option")) ? localStorage.getItem("checkbox-option") : "random");
    }, [props])

    function changeCheckBox(e) {
        if (e.target.className === "cb-active") {
            $(".cb-active").prop("checked", true);
        } else {
            $(".cb-active").prop("checked", false);
            $(".cb-active").removeClass("cb-active");
            $(`#${e.target.id}`).addClass("cb-active");
            setActive(e.target.id);
            localStorage.setItem("checkbox-option", e.target.id);
        }
    }

    return (
        <div className="image-options">
            <div className="options">
                <div className="option">
                    <Checkbox
                        name="random"
                        id="random"
                        label={(props.lang === "es") ? "Imagen aleatoria" : "Random image"}
                        checked={active === "random"}
                        onChange={changeCheckBox}
                    />
                    <Checkbox
                        name="fav"
                        id="fav"
                        label={(props.lang === "es") ? "Solo imágenes favoritas" : "Only favorite images"}
                        checked={active === "fav"}
                        onChange={changeCheckBox}
                    />
                    <Checkbox
                        name="selected"
                        id="selected"
                        label={(props.lang === "es") ? "Solo imagen seleccionada" : "Only selected image"}
                        checked={active === "selected"}
                        onChange={changeCheckBox}
                    />
                </div>
            </div>
        </div>
    )
}

export default ImageOptions
